module.exports={
	"Form": "ObservationApprovalStateViewManifest",
	"Scope": "ObservationApprovalState-View",
	"Descriptors":
	{
		"ObservationApprovalStateDetails.IDObservationApprovalState":
		{
			"Name": "ID",
			"Hash": "ObsStateView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.GUIDObservationApprovalState":
		{
			"Name": "GUID",
			"Hash": "ObsStateView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "ObsStateView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ObsStateView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ObsStateIdentity",
				"Group": "ObsStateIdentity"
			}
		},
		"ObservationApprovalStateDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsStateView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		},
		"ObservationApprovalStateDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsStateView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		},
		"ObservationApprovalStateDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsStateView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		},
		"ObservationApprovalStateDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsStateView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStateAudit",
				"Group": "ObsStateAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStateIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStateIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsStateAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsStateAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
